class ReviewedSongs {
    constructor(data) {
        this.data = data;
        this.take = 10;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': App.user.id,
            'reviewed': this.data.reviewType,
            'take': this.take,
            'skip': (this.data.page - 1) * this.take,
            'add_separator': 'song_reviewed_at',
            'order_recent_by_publish_date': false,
            'order_recent_by_review_month': true,
            'favorites_first': true,
        };
    }
}

export default ReviewedSongs;
